var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoOnBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 197 33",
    style: {
      enableBackground: "new 0 0 197 33"
    },
    xmlSpace: "preserve",
    width: 186,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#D63F94;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.5,32.4V6h1.8v26.4H36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.5,13.2h1.9v2.3C46.1,14,48,13,50.8,13c5.1,0,7.3,3.3,7.3,7.8v11.7h-1.9V20.9c0-3.8-1.8-6.1-5.4-6.1 c-3.6,0-5.4,2.4-5.4,5.9v11.7h-1.9V13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.9,14.8c-1.8,0-3.3,1.1-3.3,2.9c0,2,1.5,2.7,3.6,3.4c2.8,1,6,2.1,6,6.1c0,3.1-2.4,5.6-6.2,5.6 c-3.7,0-5.6-2.1-6.6-4.1l1.6-1c0.8,1.8,2.6,3.1,5,3.1c2.8,0,4.3-1.4,4.3-3.7c0-2.7-2.4-3.4-4.9-4.3c-2.3-0.8-4.7-1.9-4.7-5.1 c0-2.7,2.3-4.8,5.2-4.8c2.5,0,4,0.9,5.3,2.2l-1.4,1.2C70.9,15.3,69.7,14.8,67.9,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9,15.1v-1.9h3.4V6h1.9v7.1h3.2v1.9h-3.2v17.3h-1.9V15.1H76.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.2,22.8c0-5.5,4.3-9.9,9.7-9.9c3.1,0,5.8,1.4,7.5,3.6v-3.4h1.9v19.3h-1.9v-3.3c-1.8,2.2-4.5,3.6-7.5,3.6 C91.6,32.8,87.2,28.3,87.2,22.8z M97,30.9c4.4,0,7.9-3.6,7.9-8.1s-3.5-8.1-7.9-8.1c-4.4,0-7.9,3.6-7.9,8.1S92.6,30.9,97,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.2,6h1.9v9.8c1-1.6,2.6-2.8,5.6-2.8c5.1,0,7.5,3.1,7.5,7.8v11.8h-1.9V20.9c0-3.8-1.8-6.1-5.6-6.1 c-3.7,0-5.6,2.6-5.6,5.1v12.5h-1.9V6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.2,32.8c-5.4,0-9.7-4.4-9.7-9.9c0-5.5,4.3-10,9.7-10c5.4,0,9.7,4.5,9.7,10 C167.9,28.3,163.6,32.8,158.2,32.8z M158.2,30.9c4.4,0,7.9-3.6,7.9-8.1s-3.5-8.1-7.9-8.1s-7.9,3.6-7.9,8.1S153.8,30.9,158.2,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.8,17.1L118.8,17.1c-2.8-1.2-5.5-2.3-5.5-5.1c0-2.2,1.6-4.4,5.3-4.4c3.2,0,4.7,1.6,5.3,2.5l0.1,0.1 l1.8-0.7l-0.1-0.2c-0.8-1.3-2.7-3.5-7.1-3.5c-2,0-3.8,0.6-5.1,1.7c-1.3,1.1-2,2.7-2,4.5c0,4.2,3.6,5.7,6.5,6.9 c3.2,1.3,6.6,2.7,6.6,6.6c0,2-0.8,5.4-6.3,5.4c-3.4,0-5.5-1.5-6.5-4.6l0-0.1l-1.9,0.6l0,0.1c1.2,3.9,3.9,5.8,8.3,5.8 c5.2,0,8.2-2.6,8.2-7.2C126.4,20.8,122.8,18.9,118.8,17.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "195.1,13.2 188.8,29.4 183.7,13.4 181.7,13.4 176.6,29.4 170.3,13.2 168.3,13.2 175.7,32.5  177.7,32.5 182.7,16.4 187.7,32.5 189.6,32.5 197.2,13.2  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0.2,13.4 0.2,32.1 10.6,32.1 10.6,30.4 1.9,30.4 1.9,14.1 14.2,2.5 26.6,14.1 26.6,30.4 17.9,30.4  17.9,32.1 28.3,32.1 28.3,13.3 14.2,0.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.5,25.3c-3.2,0-6.2-1.7-7.8-4.5c0,0.1,1.5-0.9,1.5-0.9c1.3,2.2,3.7,3.6,6.3,3.6c2.6,0,5-1.4,6.3-3.6 c-0.1-0.1,1.6,0.9,1.5,0.9C20.7,23.5,17.7,25.3,14.5,25.3z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnBlack);
export default __webpack_public_path__ + "static/media/logo-on-black.04b642bcab7223dcebc8f3d4e273616d.svg";
export { ForwardRef as ReactComponent };